export default __webpack_public_path__ + "static/media/10.e9b581d8.svg";